import { QueryClient } from 'react-query'
import { useRouter } from 'next/router'
import Navigation from 'components/navigation'
import Footer from 'common/footer'
import PlanetSection from 'home/planet-section'
import { dehydrate } from 'react-query/hydration'
import InternalError from 'errors/internal-error'
import { prefetchStudentProject, useStudentProject } from 'querys/student-projects'
import ProjectIframe from 'projects/students/project-iframe'
import ProjectStudentsHero from 'projects/students/student-project-hero'
import OpenGraph from 'common/open-graph'

function StudentProject() {
  const router = useRouter()
  const { data, isLoading, error } = useStudentProject()

  if (isLoading) return null

  if (error?.message === 'User Unauthorized') {
    router.push(`/login?next=${router.asPath}`)
    return null
  }
  if (error?.message === 'Deploy') return <InternalError />
  if (error?.message === 'Internal Error') return <InternalError />

  const { title, thumbnail, student: { full_name } } = data

  return (
    <>
      <OpenGraph
        title={`${title} por ${full_name}`}
        image={thumbnail}
      />
      <Navigation maxWidth="1336px" />
      <ProjectStudentsHero />
      <ProjectIframe />
      <PlanetSection />
      <Footer background="var(--darkBlue)" />
    </>
  )
}

export async function getServerSideProps({ params: { uuid } }) {
  const queryClient = new QueryClient()
  await prefetchStudentProject({ queryClient, uuid })
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  }
}

export default StudentProject
